import React, { Component } from "react";
import { adminService, networkErrorHelper } from "libs";
import { MTable } from "components/table";
import { Container } from 'design-react-kit';
import { BoxDanger } from 'components/misc';

import {
  MToggle,
} from 'components/forms';

import { NavLink } from 'react-router-dom';
import { ROUTES } from 'const';

import {
  MnemoLoading,
  ModalHandler
} from "components/misc";

import ReactHtmlParser from 'react-html-parser';

class LibraryManager extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      payload: [],
      payloadToRender: [],
      isVisible: true,
      searchFilter: {
        searchFilter: {
          isVisible: true
        }
      },
      rndKey: 0,
    }
  }

  //--- ---
  tableConfig = {
    columns: [
      {
        id: 'id', // identifier of columns
        Header: 'Column 0',
        isVisible: false, // IMPORTANT: hidden columns
        accessor: 'id', // accessor is the "key" in the data

      },
      {
        id: 'name',
        Header: 'Categoria',
        accessor: 'name',
      },
      {
        id: 'cntBooks',
        Header: 'Libri',
        accessor: 'cntBooks',
      }
    ],
    actions: [
      {
        id: 'books',
        accessor: 'id',
        label: 'Libri',
        icon: 'it-list',
        className: 'MTable-actions',
        onClick: (e, value) => {
          window.location.href = ROUTES.LIBRARY_BOOK_MANAGER + '/category/' + value;
        }
      },
      {
        id: 'detail',
        accessor: 'id',
        label: 'Dettagli',
        icon: 'it-file',
        className: 'MTable-actions',
        onClick: (e, value) => {
          window.location.href = ROUTES.LIBRARY_CATEGORY_FORM + '/' + value;
        }
      },     
      {
        id: 'delete',
        accessor: 'id', // field value received in the onclick event
        label: 'Elimina',
        icon: 'it-delete',
        className: 'MTable-actions',
        onClick: (e, value) => { this.deleteRecord(e, value) }
      }
    ]
  }
  

  //--- ---


  componentDidMount() {
    this.loadAllLibraryCategory(this.state.searchFilter);
  }

  //--- start functions to delete procedure ---
  deleteRecord(e, value) {
    ModalHandler.show(value, 'Eliminazione definitiva del dato',
      'vuoi davvero eliminare?', null, this.deleteConfirm);
  }


  deleteConfirm = (value) => {
    adminService.deleteLibraryCategory(value).then(({ data }) => {    
      this.setState({ loading: true });
      this.loadAllLibraryCategory(this.state.searchFilter);
    })
      .catch(error => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      });
  }
  //--- end functions to delete procedure ---


  loadAllLibraryCategory(filter) {
        
        // check allowed filter by idparent
        if(parseInt(this.props.idLibraryCategory) > 0){
          filter = {searchFilter: {...filter.searchFilter, idParent: parseInt(this.props.idLibraryCategory)}};
        }
    
        adminService.loadAllLibraryCategory(filter).then(({ data }) => {

        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.libraryCategories).forEach(([key, val]) => {
          
          val.isVisible = (val.isVisible) ? 'visibile' : 'non visibile';

          items.push(val);
        });
        //--- end: prepare reactTable ---

        const parseItems = items.map((item)=>{
          return {...item, name: ReactHtmlParser(item.name)}
        })

        this.setState({
          loading: false,
          payload: items,
          payloadToRender: parseItems,
          rndKey: Math.floor((Math.random() * 1000) + 1)
        });
      })
      .catch(error => {
        //console.log(error);
        this.setState({ loading: false });
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }else{
          this.setState({
            payload:[],
            payloadToRender:[],
            rndKey: Math.floor((Math.random() * 1000) + 1)
          })          
        }
      });
  }  

  onChangeFilterisVisible = () => {
    let isVisible = !this.state.isVisible;

    this.setState({
      isVisible,
      searchFilter: {
        searchFilter: {
          isVisible
        }
      }
    }, () => {
      this.loadAllLibraryCategory(this.state.searchFilter);
    });
  }//onChangeFilterisVisible

  //--- ---

  render() {

    const { loading } = this.state;

    return (
      <>
        <div className="container mt-8 mb-4 mt-4">
        {(parseInt(this.props.idLibraryCategory) === 0 || isNaN(parseInt(this.props.idLibraryCategory))) && (
          <section className="m-0">
          <div className="form-row m-0 p-0">
              <div className="col-md-9">
                <div className="col-md-5">
                  <MToggle
                    id='isVisible'
                    name='isVisible'
                    label="Non Attive/Attive"
                    value={this.state.isVisible}
                    disabled={false}
                    onChange={this.onChangeFilterisVisible}
                  />
                </div>
              </div>              

              <div className="col-md-2 text-right">
                <NavLink to={ROUTES.LIBRARY_CATEGORY_FORM} className="btn btn-primary bg-dark pb-2">Nuova Categoria</NavLink>
              </div>

              <div className="col-md-1 text-right">
                <NavLink to={ROUTES.LIBRARY_AUTHOR_MANAGER} className="btn btn-primary bg-dark pb-2">Autori</NavLink>
              </div>
          </div>
          </section>
        )}

          <hr />

          <section className="my-4">
            {loading ? (<MnemoLoading></MnemoLoading>) : (
              <Container>
                <MTable
                  key={this.state.rndKey}
                  tableData={this.state.payloadToRender}
                  tableConfig={this.state.searchFilter.searchFilter.deleted ? this.tableConfigDelete : this.tableConfig}
                />
              </Container>
            )}            

            {(this.state.payload.length === 0) && (<BoxDanger key="nrp-1" className="my-3">
              Categorie Libreria.
              <div className="small text-info">
                  Nessun dato presente.
              </div>
            </BoxDanger>)}
          </section>
        </div>
      </>
    );
  }
}

export default LibraryManager;
